const map = {
	"./digital-payment.webp": 11479,
	"./e-commerce-software.webp": 7849,
	"./finance-payment.webp": 89653,
	"./finance-software.webp": 21872,
	"./healthcare-payment.webp": 86888,
	"./healthcare-software.webp": 60619,
	"./hhrr-payment.webp": 13571,
	"./ico-bag.png": 20814,
	"./ico-hammer.png": 28892,
	"./ico-heart.png": 19508,
	"./ico-puzzle.png": 98158,
	"./ico-statistics.png": 38111,
	"./ico-store.png": 87875,
	"./ico-stroke-architecture.png": 68928,
	"./ico-stroke-cases.png": 94402,
	"./ico-stroke-cube.png": 24842,
	"./ico-stroke-flow.png": 21341,
	"./ico-stroke-microservices.png": 18601,
	"./ico-stroke-trees.png": 20434,
	"./law-payment.webp": 47135,
	"./legal-issues-software.webp": 24434,
	"./marketplaces-software.webp": 59390,
	"./startups-payment.webp": 65845
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80512;